import { TeamOutlined } from '@ant-design/icons';

import { Tile, TileBody, TileHeader } from '../../../../components/shared';
import { Empty } from '../../../../components/ui';
import { useT } from '../../../../i18n';
import { cn } from '../../../../lib/cn';
import { roleColor, roleInitials } from '../../../../lib/role-avatar';
import type { VaiQuyen } from '../../nghiep-vu/quyen-du-lieu';

/**
 * Cột vai bên trái của cả hai ma trận. Cùng bộ class ở hai tab: hai tab cạnh nhau mà hàng vai trông khác nhau thì người
 * dùng đọc thành hai màn khác nhau, và dấu "đang chọn ai" mất hẳn.
 *
 * Liệt kê MỌI vai kèm trạng thái gọn để so "trưởng phòng thấy gì mà nhân viên không" bằng mắt, không phải bằng cách bấm
 * qua lại rồi nhớ.
 */
export function DanhSachVai({
  ds, chon, onChon, tomTat, cham,
}: {
  ds: VaiQuyen[];
  chon: string;
  onChon: (role: string) => void;
  tomTat: (role: string) => string;
  /** Lớp màu chấm trạng thái của vai; bỏ trống thì không vẽ chấm. */
  cham?: (role: string) => string;
}) {
  const { t } = useT();
  return (
    <Tile span="lg:col-span-3" className="h-fit">
      <TileHeader title={t('troLyAiBotQuyenDuLieu.vai')} icon={<TeamOutlined />} tone="orange" />
      <TileBody className="px-1.5 py-1.5">
        {ds.length === 0 ? (
          <Empty title={t('troLyAiBotQuyenDuLieu.khongCoVai')} className="py-6" />
        ) : (
          <ul aria-label={t('troLyAiBotQuyenDuLieu.danhSachVai')} className="space-y-0.5">
            {ds.map((a) => {
              const dangChon = a.role === chon;
              return (
                <li key={a.role}>
                  <button
                    type="button"
                    aria-current={dangChon ? 'true' : undefined}
                    onClick={() => onChon(a.role)}
                    className={cn(
                      'flex w-full items-center gap-2.5 rounded px-2.5 py-2 text-start transition',
                      dangChon ? 'bg-primary-50 ring-1 ring-primary-200' : 'hover:bg-subtle',
                    )}
                  >
                    {/* `roleColor` trả một CLASS Tailwind, không phải mã màu — đặt vào `className`, không vào `style`. */}
                    <span
                      aria-hidden
                      className={cn(
                        'flex size-9 shrink-0 items-center justify-center rounded-lg text-xs font-bold text-content-inverse',
                        roleColor(a.label),
                      )}
                    >
                      {roleInitials(a.label)}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span
                        className={cn(
                          'block truncate text-xs font-medium',
                          dangChon ? 'text-primary-700' : 'text-content-primary',
                        )}
                      >
                        {a.label}
                      </span>
                      <span className="mt-0.5 block truncate text-xs text-content-muted">{tomTat(a.role)}</span>
                    </span>
                    {cham ? <span aria-hidden className={cn('size-2 shrink-0 rounded-full', cham(a.role))} /> : null}
                  </button>
                </li>
              );
            })}
          </ul>
        )}
      </TileBody>
    </Tile>
  );
}
